import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { localisationMaster } from 'Localisation/Localisation'
import { addZero } from 'helpers/math'
import ProductionCalendarStore from './productionCalendarStore'
import ContentHeader from 'components/ContentBox/Global/ContentHeader'
import CalendarMonth from './CalendarMonth'
import { ReactComponent as ArrowLeftIcon } from 'components/UI/icons/arrow-left-circle.svg'
import { ReactComponent as ArrowRightIcon } from 'components/UI/icons/arrow-right-circle.svg'
import st from './ProductionCalendar.module.scss'

const createYear = () => Array.from({ length: 12 }, (v, i) => addZero(++i))

const ProductionCalendar = () => {
  const { year, fetchProdCalendarDay, setYear } = ProductionCalendarStore

  useEffect(fetchProdCalendarDay, [])

  return (
    <>
      <ContentHeader title='Производственный календарь'>
        <div className={st.info}>
          {localisationMaster('text_2', 'groups/calendar')}
          {localisationMaster('text_3', 'groups/calendar')}
          {localisationMaster('text_4', 'groups/calendar')}
        </div>
      </ContentHeader>
      <div className={st.wrapper}>
        <div className={st.box}>
          {year} year
          <div className={st.btns}>
            <ArrowLeftIcon onClick={() => setYear(year - 1)} />
            <ArrowRightIcon onClick={() => setYear(year + 1)} />
          </div>
        </div>
        <div className={st.calendar}>
          {createYear(year).map((month) => (
            <CalendarMonth key={month} month={month} />
          ))}
        </div>
      </div>
    </>
  )
}

export default observer(ProductionCalendar)
